import { numberDecimalOnly, numberOnly } from 'helpers'

import { REGULAR_PAYSLIP_DAY_FORM_KEYS } from './regularPayslipTableColumns'

export const PAYROLL_DECIMAL_DAY_FIELD_KEYS: readonly string[] = REGULAR_PAYSLIP_DAY_FORM_KEYS

export const sanitizePayrollNumericFieldValue = (fieldKey: string, rawValue: string) => {
  if (PAYROLL_DECIMAL_DAY_FIELD_KEYS.includes(fieldKey)) {
    return numberDecimalOnly(rawValue)
  }
  return numberOnly(rawValue)
}
